import React from 'react';

const Help = () => (
  <div className={'text-center'} style={{ height: '1000px' }}>
    <h1>Какой-то контент помощи...</h1>
  </div>
);

export default Help;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/Help/Help.js